import axios from '../axios'

/*
 * 排行榜
 */

export const selectByPage = (data) => {
    return axios({
        url: '/project/selectRankByPage',
        method: 'post',
        data
    })
}

export const updatePlatformConfig = (data) => {
    return axios({
        url: '/platformConfig/update',
        method: 'post',
        data
    })
}

export const selectPlatformConfig = (data) => {
    return axios({
        url: '/platformConfig/api/selectPlatformConfig',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/pms/ranking.js